import store from '@/store'
import axios from 'axios'

export default {
  async getRatingByOrderIdFromApi(orderId) {
    try {
      let response = await axios.get(store.getters.getRatingApi + '/ratings/orders/' + orderId)
      return response.data
    } catch (e) {
      let error = {e}
      return {error: error.e.response.data}
    }
  }
}
